import { BaseAPI } from './base.api';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';

export class AutovistoriaAPI extends BaseAPI<any> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api_dash/v1`;
  }

  public listStatus(): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/inspections/statuses`)
  }
}
